import React from 'react';

import RelChart from '../../components/visualize/RelChart';

/**
 * Handle data from AWS instead of our DB
 */
export const participantNumberDataKey = (
  interval: string,
  end: 'max' | 'min'
): string => {
  const intervalV2 = interval == '52w' ? '1y' : interval;
  return `${intervalV2}:total_no:${end}`;
};

interface Props {
  participantNumChangeInterval: string;
  item: any;
}
const ParticipantNumberLevel: React.FC<Props> = ({
  participantNumChangeInterval,
  item,
}) => {
  const is_v2_data =
    item[participantNumberDataKey(participantNumChangeInterval, 'min')] !=
    undefined;

  const {
    total_no,
    [is_v2_data
      ? participantNumberDataKey(participantNumChangeInterval, 'max')
      : `total_no_${participantNumChangeInterval}_high`]: total_no_highest,
    [is_v2_data
      ? participantNumberDataKey(participantNumChangeInterval, 'min')
      : `total_no_${participantNumChangeInterval}_low`]: total_no_lowest,
  } = item;

  return (
    <RelChart
      low={total_no}
      high={total_no}
      current={total_no}
      lowest={total_no_lowest}
      highest={total_no_highest}
      lowestLabel={total_no_lowest}
      highestLabel={total_no_highest}
    />
  );
};

export default React.memo(ParticipantNumberLevel);
